module.exports = __webpack_public_path__ + "media/components/phones-13551af63a2d437a9ebd4a8d99c46870.png";